import { date } from "quasar";
import { Notify } from 'quasar'

export namespace Utils {
    export class Date {
        static formatDate(dateStr: string, format: string = "DD/MM/YYYY"): string {
            if (!dateStr || dateStr == '0001-01-01T00:00:00') return "";
            return date.formatDate(dateStr, format);
        }
    }
    export class Notification {
        static notifyPositive(msg: string = "", icon: string = "check_circle", position: any = "bottom", timeout: number = 0) {
            let obj = {
                color: 'positive',
                message: msg,
                position: position,
                icon: icon
            };
            if (timeout > 0) obj["timeout"] = timeout;
            Notify.create(obj);
        }

        static notifyNegative(msg: string = "", icon: string = "warning", position: any = "bottom") {
            Notify.create({
                color: 'negative',
                message: msg,
                position: position,
                icon: icon
            })
        }

        static notifyWarning(msg: string = "", icon: string = "warning", position: any = "bottom") {
            Notify.create({
                color: 'warning',
                message: msg,
                position: position,
                icon: icon
            })
        }

        static notifyInfo(msg: string = "", icon: string = "info", position: any = "bottom") {
            Notify.create({
                color: 'info',
                message: msg,
                position: position,
                icon: icon
            })
        }

        static notifyCustom(msg: string = "", position: any = "bottom", color: string = "white", textColor: string = "black", icon: string = "") {
            Notify.create({
                message: msg,
                position: position,
                color: color,
                textColor: textColor,
                icon: icon
            })
        }
    }
}